import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

type spinnerStyleProps = { size: number };
export const useSpinnerStyles = makeStyles((theme: Theme) =>
	createStyles({
		spinnerOverride: (props: spinnerStyleProps) => ({
			width: `${props.size}px`,
			height: `${props.size}px`,
		}),
		spinner: {
			width: `80px`,
			height: `80px`,
			border: "5px solid #f3f3f3",
			borderTop: `5px solid ${theme.palette.primary.main}`,
			borderRadius: "50%",
			animation: "$spin 2s linear infinite",
		},
		"@keyframes spin": {
			"0%": {
				transform: "rotate(0deg)",
			},
			"100%": {
				transform: "rotate(360deg)",
			},
		},
	})
);
